import { Background, Container, ContentHeader } from '@/components/wm';
import { Partner } from '@/pages/WiseStore/Content/partner';
import * as React from 'react';

export default function Wisestore({ integrationPartners, licenses, organizationId }) {
    const license = partnerId => {
        return licenses.find(license => license.partner_id === partnerId);
    };

    const
        activePartners = integrationPartners.filter(partner => license(partner.id)),
        availablePartners = integrationPartners.filter(partner => !license(partner.id) && partner.state !== 'upcoming'),
        upcomingPartners = integrationPartners.filter(partner => partner.state === 'upcoming');

    return (
        <Background>
            <Container>
                <ContentHeader title={ i18next.t('integrations.active_integrations') }/>
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4">
                    {activePartners.map(partner => (
                        <Partner key={partner.id} license={license(partner.id)} organizationId={organizationId} partner={partner}/>
                    ))}
                </div>
            </Container>
            <Container>
                <ContentHeader title={ i18next.t('integrations.available_integrations') }/>
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4">
                    {availablePartners.map(partner => (
                        <Partner key={partner.id} license={license(partner.id)} organizationId={organizationId} partner={partner}/>
                    ))}
                </div>
            </Container>
            <Container>
                <ContentHeader title={ i18next.t('integrations.upcoming_integrations') }/>
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4">
                    {upcomingPartners.map(partner => (
                        <Partner key={partner.id} license={license(partner.id)} organizationId={organizationId} partner={partner}/>
                    ))}
                </div>
            </Container>
        </Background>
    );
}
